import { heroLead, leadCards } from "@/mocks/site";

export default function Hero() {
  return (
    <section id="top" className="mx-auto max-w-[1400px] px-4 pb-4 pt-8 md:px-6 md:pt-10">
      {/* 首页头版标记 */}
      <div className="mb-6 flex flex-wrap items-center justify-between gap-2 border-b border-background-200 pb-3">
        <h1 className="eyebrow flex items-center gap-2 text-[13px] font-bold text-foreground-700">
          <i className="ri-newspaper-line text-primary-500" />
          头版 · 今日重锤
        </h1>
        <span className="text-xs text-foreground-400">2026-09-05 · 编辑部正在逐条核验</span>
      </div>

      {/* 主导大稿 —— 上疏区保持呼吸感 */}
      <article className="rise-in">
        <div className="grid gap-8 lg:grid-cols-12 lg:gap-10">
          <div className="lg:col-span-7">
            <div className="flex flex-wrap items-center gap-2">
              <span className="eyebrow rounded-sm bg-primary-600 px-2.5 py-1 text-[11px] font-bold text-background-50">
                直播电商 · 石锤
              </span>
              <span className="flex items-center gap-1 text-xs text-foreground-500">
                <i className="ri-time-line" />
                {heroLead.time}
              </span>
              {heroLead.verified && (
                <span className="flex items-center gap-1 text-xs font-medium text-primary-600">
                  <i className="ri-verified-badge-fill" />
                  证据已核验
                </span>
              )}
            </div>

            <h2 className="mt-5 font-display text-3xl font-black leading-[1.25] tracking-tight text-foreground-950 md:text-[42px]">
              {heroLead.title}
            </h2>

            <p className="mt-5 max-w-3xl text-[15px] leading-7 text-foreground-600 md:text-base">
              {heroLead.summary}
            </p>

            <div className="mt-6 flex flex-wrap gap-2">
              {heroLead.evidence.map((e) => (
                <span
                  key={e}
                  className="flex items-center gap-1.5 rounded-full border border-background-300 bg-background-100 px-3 py-1 text-xs text-foreground-700"
                >
                  <i className="ri-file-shield-2-line text-primary-500" />
                  {e}
                </span>
              ))}
            </div>

            <div className="mt-7 flex flex-wrap items-center gap-4">
              <a
                href="#timeline"
                className="whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600"
              >
                查看完整证据链 <i className="ri-arrow-right-line ml-1" />
              </a>
              <a
                href="#chat"
                className="whitespace-nowrap rounded-md border border-foreground-900/15 bg-background-50 px-5 py-2.5 text-sm font-semibold text-foreground-900 transition-colors hover:border-primary-400 hover:text-primary-600"
              >
                进入实锤专区
              </a>
              <div className="flex items-center gap-4 text-xs text-foreground-500">
                <span className="flex items-center gap-1">
                  <i className="ri-eye-line" /> {heroLead.readCount} 阅读
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-chat-3-line" /> {heroLead.commentCount} 讨论
                </span>
              </div>
            </div>
          </div>

          {/* 主图 + 石锤图章 */}
          <div className="relative lg:col-span-5">
            <div className="overflow-hidden rounded-lg bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=moody%20editorial%20photo%20of%20a%20newsroom%20evidence%20board%20pinned%20with%20printed%20chat%20screenshots%2C%20shipping%20labels%20and%20timeline%20notes%2C%20red%20string%20connecting%20evidence%2C%20warm%20desk%20lamp%20glow%2C%20dark%20background%2C%20investigative%20journalism%2C%20crimson%20and%20amber%20accent%20lights&width=900&height=700&seq=hero-main-01&orientation=portrait"
                alt="曝瓜网假一赔十证据链实锤头版"
                title="曝瓜网 假一赔十 实锤 证据链 头版"
                className="h-[360px] w-full object-cover object-top md:h-[520px]"
              />
            </div>
            <span className="stamp-in absolute right-3 top-3 flex h-20 w-20 -rotate-12 items-center justify-center rounded-full border-[3px] border-primary-500 bg-background-50/85 font-display text-lg font-black tracking-wide text-primary-600">
              实锤
            </span>
          </div>
        </div>
      </article>
    </section>
  );
}